module.exports = __webpack_public_path__ + "static/media/visa.2f7e1d5d.svg";